import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ArrowLeft, UserPlus, LayoutDashboard, ArrowRight, Lock } from "lucide-react";

const STAFF_ROLES = ["evaluator", "admin", "superadmin"];

export default function Manual() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isStaff = STAFF_ROLES.includes(user?.role);
  const cards = [
    {
      to: "/manual-usuario",
      icon: UserPlus,
      title: "Manual del Socio Postulante",
      desc: "Cómo crear la cuenta, completar el asistente de 5 pasos, adjuntar documentos y enviar la solicitud.",
      testid: "manual-card-usuario",
      staffOnly: false,
    },
    {
      to: "/manual-evaluador",
      icon: LayoutDashboard,
      title: "Manual del Evaluador / Administrador",
      desc: "Ingreso seguro, revisión y resolución de solicitudes, tabla de beneficios y Portal Instituto Hebreo.",
      testid: "manual-card-evaluador",
      staffOnly: true,
    },
  ].filter((c) => !c.staffOnly || isStaff);
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-white border-b border-border">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2" data-testid="manual-home-link">
            <img src="/eim-logo.png" alt="EIM" className="w-9 h-9 object-contain" />
            <span className="font-heading font-extrabold text-lg text-primary">EIM Becas</span>
          </button>
          <Button variant="ghost" onClick={() => navigate("/")} data-testid="manual-back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" /> Volver
          </Button>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 py-14 space-y-8">
        <div className="text-center space-y-3">
          <img src="/eim-logo.png" alt="Estadio Israelita Maccabi" className="w-16 h-16 object-contain mx-auto" />
          <h1 className="text-3xl sm:text-4xl font-black text-primary">Manuales de EIM Becas</h1>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Elige el manual que quieres ver. Cada uno se puede imprimir o guardar como PDF para enviarlo por correo.
          </p>
          <div className="inline-flex items-center gap-2 bg-secondary text-primary px-4 py-2 rounded-full text-sm font-semibold">
            <Lock className="w-4 h-4" /> Sitio privado y confidencial
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {cards.map((c) => (
            <button
              key={c.to}
              onClick={() => navigate(c.to)}
              className="text-left bg-white rounded-2xl border border-border p-7 btn-lift hover:border-primary transition-colors"
              data-testid={c.testid}
            >
              <div className="w-12 h-12 rounded-xl bg-secondary grid place-items-center mb-4">
                <c.icon className="w-6 h-6 text-accent" />
              </div>
              <h2 className="text-lg font-bold text-primary mb-2">{c.title}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed mb-4">{c.desc}</p>
              <span className="inline-flex items-center text-primary font-semibold text-sm">
                Abrir manual <ArrowRight className="w-4 h-4 ml-1" />
              </span>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
